import React, { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";
import { useForm } from "../../../../../../Base/Hooks/useForm";
import { InputText } from "primereact/inputtext";
import Loader from "../../../../../../Base/Components/Loader/Loader";
import { Toast } from "primereact/toast";
import { toastShow } from "../../../../../../Base/Services/ToastService";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import {
  editarTipoDispositivo,
  guardarTipoDispositivo,
} from "../../../../../../API/IT/Dispositivos/DispositivosRequest";

const TipoDispositivoCRUD = ({
  listTipo,
  showDialog,
  tipoDispositivo,
  setShowDialog,
  getInfo,
}) => {
  const { userAuth } = useContext(AuthContext);
  const toastDialog = useRef(null);

  const [loading, setLoading] = useState(false);

  const initialValues = {
    IdTipoDispositivo: -1,
    TipoDispositivo: "",
    CodigoInterno: "",
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } =
    useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);

    setValues({
      ...tipoDispositivo,
      TipoDispositivo: tipoDispositivo?.TipoDispositivo,
      CodigoInternorca: tipoDispositivo?.CodigoInterno,
    });

    setLoading(false);
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.TipoDispositivo) {
      error.TipoDispositivo = true;
      error.error = true;
    }
    setError(error);
    return error;
  };

  const verificarDuplicado = () => {
    const duplicado = listTipo.find(
      (r) =>
        r.IdTipoDispositivo !== values.IdTipoDispositivo &&
        r.TipoDispositivo === values?.TipoDispositivo
    );

    if (duplicado) {
      let mensaje = "Ya existe una tipo con el mismo valor de: ";
      if (duplicado.TipoDispositivo === values.TipoDispositivo)
        mensaje += `${duplicado.TipoDispositivo} `;
      return mensaje;
    }

    return null;
  };

  const agregarTipoDispositivo = async () => {
    const e = verificarInfo();

    if (!e.error) {
      const duplicado = verificarDuplicado();

      if (duplicado) {
        toastShow(toastDialog, "error", "Error", duplicado);
        return;
      }

      const a = {
        IdTipoDispositivo: values?.IdTipoDispositivo,
        TipoDispositivo: values?.TipoDispositivo,
        CodigoInterno: values?.CodigoInterno,
        IdUserCreated: userAuth?.IdUser,
        IdUserEdit: userAuth?.IdUser,
      };

      setLoading(true);

      if (a.IdTipoDispositivo > 0) {
        const resultado = await editarTipoDispositivo(a);
        toastShow(
          toastDialog,
          "success",
          "Datos Editados",
          "Tipo dispositivo editado correctamente"
        );
        getInfo();
        setTimeout(() => {
          onHide();
          setLoading(false);
        }, 1300);
      } else {
        const resultado = await guardarTipoDispositivo(a);
        toastShow(
          toastDialog,
          "success",
          "Datos Agregados",
          "Tipo dispositivo agregado correctamente"
        );
        getInfo();
        setTimeout(() => {
          onHide();
          setLoading(false);
        }, 1300);
      }
      setLoading(false);
    }
  };

  const onHide = () => {
    setShowDialog(false);
    resetForm();
    setError({});
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={tipoDispositivo?.IdTipoDispositivo > 0 ? "Editar" : "Agregar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          agregarTipoDispositivo();
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
      getValoresIniciales();
    }
  }, [showDialog]);

  const dialogTitle =
    tipoDispositivo?.IdTipoDispositivo > 0 ? "Editar Tipo" : "Agregar Tipo";
  return (
    <div>
      <Dialog
        visible={showDialog}
        modal
        className="modal__contenedor1"
        footer={DialogFooter}
        onHide={onHide}
        header={dialogTitle}
        style={{ width: "35%" }}
      >
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ margin: "auto" }}>
            <Toast ref={toastDialog} style={{ zIndex: 50000 }} />

            <div className="modal__input-contenedor gap-2">
              <div className="field col-6">
                <span className="p-float-label">
                  <InputText
                    name="TipoDispositivo"
                    value={values?.TipoDispositivo}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.TipoDispositivo ? "p-invalid" : ""}
                  />
                  <label htmlFor="TipoDispositivo">Tipo Dispositivo</label>
                </span>
              </div>

              <div className="field col-6">
                <span className="p-float-label">
                  <InputText
                    name="CodigoInterno"
                    value={values?.CodigoInterno}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                  />
                  <label htmlFor="CodigoInterno">Código Interno</label>
                </span>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default TipoDispositivoCRUD;
